/* eslint-disable import/prefer-default-export */

import isFunction from 'lodash/isFunction';

import Path from 'path';

// import throttle from 'lodash/throttle';

import React, {
  useEffect,
  useState,
  useRef,
} from 'react';
import styled, { css, createGlobalStyle } from 'styled-components';
import { fromEvent } from 'file-selector';

import AntdProgress from 'antd/lib/progress';

// import AntdIcon from 'antd/lib/icon';
import {
  UploadOutlined,
} from '@ant-design/icons';

// import { Redirect } from 'react-router-dom';

import Admin from './Admin';

const GlobalDisabledStyle = createGlobalStyle`
  html, html * {
    pointer-events: none !important;
    cursor: not-allowed;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${({ $disabled }) => $disabled && css`
    cursor: not-allowed;
    filter: grayscale(1);
    opacity: 0.5;
    * {
      pointer-events: none !important;
    }
  `}
`;

const getDashedBackgroundSrc = ({
  color = 'black',
  radius = 0,
  width = 2,
  dashArray1 = 6,
  dashArray2,
} = {}) => {
  radius = parseInt(radius, 10);
  width = parseInt(width, 10);
  dashArray1 = parseInt(dashArray1, 10);
  dashArray2 = (
    typeof dashArray2 === 'undefined'
    ? Math.round(dashArray1 * 1.3)
    : parseInt(dashArray2, 10)
  );
  // eslint-disable-next-line max-len
  return `data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='${
    radius
  }' ry='${
    radius
  }' stroke='${
    encodeURIComponent(color)
  }' stroke-width='${
    width
  }' stroke-dasharray='${
    dashArray1
  }%2c ${
    dashArray2
  }' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e`;
};

// eslint-disable-next-line max-len
const UploadArea = styled.label`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 200px;
  border-radius: ${({ theme }) => theme.less.borderRadius};
  /* border: 1px dashed ${({ theme }) => theme.less.borderColor}; */
  background-image: ${({ theme }) => `url("${getDashedBackgroundSrc({
    color: theme.less.borderColor,
    radius: theme.less.borderRadius,
  })}")`};
  cursor: pointer;
  ${({ $disabled }) => (
    $disabled
    ? css`
        pointer-events: none !important;
        * {
          pointer-events: none !important;
        }
        /* > * {
          opacity: 0.5;
        } */
      `
    : css`
        color: ${({ theme }) => theme.less.primaryColor};
      `
  )}
`;

const UploadAreaIconWrapper = styled.div`
  svg {
    opacity: 0.7;
    font-size: 40px;
  }
`;

const UploadAreaText = styled.p`
  margin: 0px;
  margin-top: 5px;
`;

const UploadInput = styled.input`
  opacity: 0;
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  cursor: pointer;
`;

const UploadProgress = styled(AntdProgress)`
  width: 100%;
  padding: 0 20px;
  max-width: 400px;
`;

// function traverseFileTree(item, path) {
//   path = path || "";
//   if (item.isFile) {
//     // Get file
//     item.file(function(file) {
//       console.log("File:", path + file.name);
//     });
//   } else if (item.isDirectory) {
//     // Get folder contents
//     var dirReader = item.createReader();
//     dirReader.readEntries(function(entries) {
//       for (var i=0; i<entries.length; i++) {
//         traverseFileTree(entries[i], path + item.name + "/");
//       }
//     });
//   }
// }

function Upload(props) {
  const {
    client,
    accept,
    acceptExtensions = [],
    // storeId,
    batchSize = 10,
    transformations,
    placeholder,
    getPlaceholder,
    getUploadArgs,
    onUploadSuccess,
    style,
    disabled,
  } = props;
  const fileInputRef = useRef();
  const propsRef = useRef();
  propsRef.current = props;
  const [files, setFiles] = useState(null);
  const filesRef = useRef(files);
  const [uploadProgress, setUploadProgress] = useState(0);
  const disabledFinal = disabled || files !== null;
  useEffect(
    () => {
      let cancelled = false;

      if (files?.length) {
        const {
          uploadedPerFile,
          totalToUpload,
        } = files.reduce(
          (agr, file, i) => {
            agr.uploadedPerFile[i] = 0;
            agr.totalToUpload += file.size;
            return agr;
          },
          {
            uploadedPerFile: [],
            totalToUpload: 0,
          },
        );

        const setProgress = (i, loaded) => {
          uploadedPerFile[i] = loaded;
          const totalUploaded = uploadedPerFile.reduce(
            (agr, uploaded) => agr + uploaded,
            0,
          );
          setUploadProgress(totalUploaded / totalToUpload);
        };

        const batchCount = Math.ceil(files.length / batchSize);
        let batchIndex = 0;

        const uploads = [];

        const uploadNextBatch = () => {
          const batch = files.slice(
            batchIndex * batchSize,
            (batchIndex + 1) * batchSize,
          );
          Promise.all([
            ...batch.map(async (file, i) => {
              const form = new FormData();
              form.set('file', file, file.name);
              const uploadArgsDefault = {
                transformations,
                meta: {
                  filepath: file.path,
                },
              };
              const uploadArgs = (
                  getUploadArgs
                ? getUploadArgs(uploadArgsDefault, propsRef.current)
                : uploadArgsDefault
              )
              return (
                client.request({
                  url: `/files?query=${encodeURIComponent(JSON.stringify(
                    uploadArgs,
                  ))}`,
                  method: 'POST',
                  data: form,
                  onUploadProgress: ({ loaded }) => setProgress(
                    (batchIndex * batchSize) + i,
                    loaded,
                  ),
                })
                .then(response => response.data)
              );
            }),
          ])
          .then((batchUploads) => {
            if (!cancelled) {
              uploads.push(...batchUploads);
            }
          })
          .catch((error) => {
            // eslint-disable-next-line no-console
            console.log('error uploading:', error);
          })
          .then(() => {
            if (!cancelled) {
              batchIndex++;
              if (batchIndex === batchCount) {
                setFiles(null);
                setUploadProgress(0);
                if (onUploadSuccess) {
                  onUploadSuccess(uploads, propsRef.current);
                }
              } else {
                uploadNextBatch();
              }
            } else {
              setFiles(null);
              setUploadProgress(0);
            }
          })
        };

        client.request({
          url: `/files/untag?query=${encodeURIComponent(JSON.stringify({
            tag: props.data?.galleryTag,
          }))}`,
          method: 'POST',
        })
        .then(() => uploadNextBatch());
      }
      return () => {
        cancelled = true;
      };
    },
    [
      files,
      client,
      batchSize,
      getUploadArgs,
      onUploadSuccess,
      transformations,
      props.data?.galleryTag,
    ],
  );
  useEffect(
    () => {
      if (fileInputRef.current) {
        ['webkitdirectory', 'directory', 'mozdirectory'].forEach((attr) => {
          fileInputRef.current.setAttribute(attr, '');
        });
      }
    },
    [fileInputRef],
  );
  if (files) {
    filesRef.current = files;
  }
  return (
    <UploadArea $disabled={disabledFinal} style={style}>
      {
        files?.length
        ? <GlobalDisabledStyle />
        : null
      }
      <UploadAreaIconWrapper>
        {
            props.getIcon
          ? props.getIcon(props)
          : <UploadOutlined />
        }
      </UploadAreaIconWrapper>
      {
          files
        ? (
            <UploadProgress
              showInfo={false}
              percent={uploadProgress * 100}
              status="active"
            />
          )
        : (
            <UploadAreaText>
              {
                  getPlaceholder
                ? getPlaceholder(props)
                : (placeholder || null)
              }
            </UploadAreaText>
          )
      }
      <UploadInput
        ref={fileInputRef}
        type="file"
        accept={accept}
        disabled={disabledFinal}
        value=""
        onChange={async (event) => {
          const newFilesRaw = await fromEvent(event.nativeEvent);
          let newFilesAllowed = [];
          if (acceptExtensions?.length) {
            newFilesAllowed = newFilesRaw.filter(file => (
              acceptExtensions.includes(Path.extname(file.path).slice(1))
            ));
          } else {
            const allowed = accept.split(',').map(x => x.trim());
            // eslint-disable-next-line max-len
            newFilesAllowed = newFilesRaw.filter(file => (
              allowed.includes(file.type)
              || allowed.includes(`${file.type.split('/')[0]}/*`)
            ));
          }
          if (newFilesAllowed.length) {
            setFiles(newFilesAllowed)
          } else {
            setFiles(null);
          }
        }}
      />
    </UploadArea>
  );
}

Admin.addToLibrary('FieldUploadRefsDropzone', (config = {}) => (
  Admin.compileFromLibrary(['FieldReact', {
    name: 'upload',
    label: null,
    ...config,
    ContentComponent: (props) => {
      const disabled = (
          isFunction(props.isDisabled)
        ? props.isDisabled(props)
        : false
      );
      return (
        <Wrapper $disabled={disabled}>
          <Upload
            {...props}
            disabled={disabled}
            storeId={props.form.getFieldValue('store')}
          />
        </Wrapper>
      );
    },
  }])
));
